import React from 'react';
import { CurrencyInputProps } from './types';
import { NumericFormat } from 'react-number-format';
import * as S from './CurrencyInputFormula.styles';

export const CurrencyInputFormula = (props: CurrencyInputProps) => {
  // @ts-expect-error CurrencyInputProps inherits MUI TextField's `value?: unknown`, wider than react-number-format's `value?: string | number | null`
  return <NumericFormat customInput={S.MaterialInputCustomFormula} thousandSeparator="," {...props} />;
};
